/** Multipart photo payloads — browser `File` or React Native `{ uri, name, type }`. */

export type MultipartPhotoFile = Blob | File | { uri: string; name: string; type: string }

export interface PricingSuggestPhotoParams {
  phone_model_id: number
  condition: string
  battery_health?: number
  release_year?: number
  storage_gb?: number
  expected_device_color?: string | null
  in_box_completeness?: 'full' | 'partial' | 'phone_only' | null
}

export interface AssessPhotoOptions {
  phone_model_id?: number
  expected_device_color?: string | null
}

export function appendPhotoFile(fd: FormData, file: MultipartPhotoFile): void {
  fd.append('file', file as Blob)
}

export function buildAssessPhotoFormData(
  file: MultipartPhotoFile,
  opts?: AssessPhotoOptions,
): FormData {
  const fd = new FormData()
  appendPhotoFile(fd, file)
  if (opts?.phone_model_id != null && opts.phone_model_id > 0) {
    fd.append('phone_model_id', String(opts.phone_model_id))
  }
  if (opts?.expected_device_color?.trim()) {
    fd.append('expected_device_color', opts.expected_device_color.trim())
  }
  return fd
}

export function buildSuggestWithPhotoFormData(
  params: PricingSuggestPhotoParams,
  file: MultipartPhotoFile,
): FormData {
  const fd = new FormData()
  fd.append('phone_model_id', String(params.phone_model_id))
  fd.append('condition', params.condition)
  if (params.battery_health != null) {
    fd.append('battery_health', String(params.battery_health))
  }
  if (params.release_year != null) {
    fd.append('release_year', String(params.release_year))
  }
  if (params.storage_gb != null) {
    fd.append('storage_gb', String(params.storage_gb))
  }
  if (params.expected_device_color?.trim()) {
    fd.append('expected_device_color', params.expected_device_color.trim())
  }
  if (params.in_box_completeness) {
    fd.append('in_box_completeness', params.in_box_completeness)
  }
  appendPhotoFile(fd, file)
  return fd
}
